<template>
  <div class="container mt-4" dir="rtl">
           <UserWelcome 
      :user="user"
      userRole="school"
      :entityName="school_name" 
    />
    <!-- 1. لوحة الفلاتر والتحكم -->
    <div class="card shadow-sm mb-4 border-top-primary no-print">
      <div class="card-header bg-white py-3">
        <h5 class="mb-0 text-primary fw-bold">
          <i class="fas fa-edit ms-2"></i> رصد درجات الأنشطة (مجمع للمدرسة)
        </h5>
      </div>

      <div class="card-body">
        <div class="row g-3">
     
          <!-- <div class="col-md-3">
            <label class="form-label fw-bold">الفصل الدراسي</label>
            <select v-model="filters.term_id" class="form-select" disabled>
              <option value="">اختر الفصل</option>
              <option v-for="t in lists.terms" :key="t.id" :value="t.id">{{ t.name }}</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">الصف الدراسي</label>
            <select v-model="filters.grade_id" class="form-select" @change="fetchGroups" disabled>
              <option value="">اختر الصف</option>
              <option v-for="g in lists.grades" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div>

          <div class="col-md-3">
            <label class="form-label fw-bold">المجموعة / الفصل</label>
            <select v-model="filters.group_id" class="form-select" disabled>
              <option value="">اختر المجموعة</option>
              <option v-for="g in lists.groups" :key="g.id" :value="g.id">{{ g.name }}</option>
            </select>
          </div> -->

          <div class="col-md-3 d-flex align-items-end">
            <button 
              @click="fetchStudents" 
              class="btn btn-primary w-100" 
              :disabled="loading || isSaving"
            >
              <span v-if="loading" class="spinner-border spinner-border-sm ms-1"></span>
              <span v-else><i class="fas fa-search ms-1"></i> عرض الطلاب</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- شريط التقدم (يظهر فقط أثناء الحفظ) -->
    <div v-if="isSaving" class="progress mb-3 shadow-sm" style="height: 25px;">
      <div 
        class="progress-bar progress-bar-striped progress-bar-animated bg-success" 
        role="progressbar" 
        :style="{ width: saveProgress + '%' }"
      >
        جاري رفع البيانات: {{ saveProgress }}%
      </div>
    </div>

    <!-- 2. جدول الرصد -->
 <div v-if="students.length > 0" class="card shadow-sm border-0">
    
    <!-- 1. رأس البطاقة (أدوات التحكم) -->
    <div class="card-header bg-white py-3 border-bottom">
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
        
        <!-- العنوان وعداد التعديلات -->
        <div class="d-flex align-items-center w-100 w-md-auto">
          <div class="icon-box bg-primary-subtle text-primary rounded-circle me-2 ms-2 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
            <i class="fas fa-users"></i>
          </div>
          <div>
            <h6 class="mb-0 fw-bold">قائمة الطلاب ({{ students.length }})</h6>
            <transition name="fade">
              <span v-if="changedCount > 0" class="badge bg-warning text-dark mt-1 animate-pulse">
                <i class="fas fa-pen me-1"></i> جاري تعديل {{ changedCount }} طالب
              </span>
            </transition>
          </div>
        </div>
        
        <!-- الأزرار (إجراءات) -->
        <div class="d-flex gap-2 w-100 w-md-auto justify-content-end">
           <button @click="applyBulkPass" class="btn btn-outline-primary btn-sm d-flex align-items-center" :disabled="isSaving">
             <i class="fas fa-magic ms-1"></i> 
             <span class="d-none d-sm-inline">ملء تلقائي (اجتياز)</span>
             <span class="d-inline d-sm-none">ملء</span>
           </button>
           
           <button @click="saveChunks" class="btn btn-success btn-sm px-4 d-flex align-items-center" :disabled="isSaving || changedCount === 0">
             <span v-if="isSaving" class="spinner-border spinner-border-sm ms-1"></span>
             <i v-else class="fas fa-save ms-1"></i> 
             <span>حفظ التعديلات</span>
           </button>
        </div>
      </div>
    </div>

    <!-- 2. جدول الرصد (قابل للتمرير) -->
    <div class="table-responsive custom-scrollbar" style="max-height: 65vh;">
      <table class="table table-bordered table-hover text-center align-middle mb-0 sticky-header">
        <thead class="table-light">
          <tr>
            <th style="min-width: 100px;">رقم الجلوس</th>
            <th style="min-width: 200px;">اسم الطالب</th>
            <th style="min-width: 100px;">الحالة</th>
            
            <!-- نشاط 1 -->
            <th style="min-width: 160px;" class="bg-blue-header">
              نشاط (1)
              <span class="d-block text-muted fw-normal font-xs mt-1">(فني / موسيقي)</span>
            </th>
            
            <!-- نشاط 2 -->
            <th style="min-width: 160px;" class="bg-green-header">
              نشاط (2)
              <span class="d-block text-muted fw-normal font-xs mt-1">(مجال صناعي/زراعي)</span>
            </th>
            
            <!-- تربية رياضية -->
            <th style="min-width: 160px;" class="bg-yellow-header">
              تربية رياضية
              <span class="d-block text-muted fw-normal font-xs mt-1">(عملي)</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(student, index) in students" :key="student.id" :class="{'row-changed': student.is_changed}">
            
            <!-- رقم الجلوس -->
            <td class="fw-bold font-monospace text-secondary bg-light">{{ student.Seating_No }}</td>
            
            <!-- الاسم -->
            <td class="text-start pe-3">
              <span class="fw-bold text-dark">{{ student.Arabic_Name }}</span>
            </td>
            
            <!-- الحالة -->
            <td>
              <span v-if="student.Damg_Status === 'نعم'" class="badge bg-warning text-dark border border-dark rounded-pill">دمج</span>
              <span v-else-if="student.Stud_Type_Id === 2" class="badge bg-secondary rounded-pill">منازل</span>
              <span v-else class="badge bg-light text-dark border rounded-pill">نظامي</span>
            </td>

            <!-- إدخال نشاط 1 -->
            <td class="bg-blue-light p-2">
              <select 
                v-model="student.activity_1" 
                @change="markDirty(student)"
                class="form-select form-select-sm shadow-sm" 
                :class="getStatusClass(student.activity_1)"
              >
                <option value="">-- اختر --</option>
                <option value="pass">اجتياز</option>
                <option value="fail">لم يجتز</option>
                <option value="absent">غائب</option>
                <option value="exempt">معفى</option>
              </select>
            </td>

            <!-- إدخال نشاط 2 -->
            <td class="bg-green-light p-2">
              <select 
                v-model="student.activity_2" 
                @change="markDirty(student)"
                class="form-select form-select-sm shadow-sm" 
                :class="getStatusClass(student.activity_2)"
              >
                <option value="">-- اختر --</option>
                <option value="pass">اجتياز</option>
                <option value="fail">لم يجتز</option>
                <option value="absent">غائب</option>
                <option value="exempt">معفى</option>
              </select>
            </td>

            <!-- إدخال تربية رياضية -->
            <td class="bg-yellow-light p-2">
               <select 
                 v-model="student.sports" 
                 @change="markDirty(student)"
                 class="form-select form-select-sm shadow-sm" 
                 :class="getStatusClass(student.sports)"
               >
                <option value="">-- اختر --</option>
                <option value="pass">اجتياز</option>
                <option value="fail">لم يجتز</option>
                <option value="absent">غائب</option>
                <option value="exempt">معفى</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <!-- 3. تذييل (ملخص) -->
    <div class="card-footer bg-light py-2 text-center small text-muted">
       تأكد من مراجعة البيانات قبل الحفظ النهائي | عدد السجلات: {{ students.length }}
    </div>
  </div>

    <!-- رسالة في حال لا يوجد نتائج -->
    <div v-else-if="searched && !loading" class="alert alert-info text-center mt-4">
       لا يوجد طلاب مسجلين لهذه المجموعة، أو لم يتم اختيار معايير البحث.
    </div>
  </div>
</template>

<script>
import api from '@/api/axios';
import UserWelcome from '@/components/UserWelcome.vue'; 
export default {
  name: "SchoolActivitiesEntry",
    components: { UserWelcome },
  data() {
    return {
      // حالات التحميل
      loading: false,
      isSaving: false,
      saveProgress: 0,
      searched: false,

      user:'',
      school_name:'',
      // الفلاتر
      filters: {
        term_id: 1,
        grade_id: 3,
        group_id: ""
      },
      
      // القوائم المنسدلة (بيانات للمثال)
      lists: {
        terms: [
            {id: 1, name: 'الفصل الدراسي الأول'}, 
            {id: 2, name: 'الفصل الدراسي الثاني'}
        ],
        grades: [
            {id: 1, name: 'الأول الإعدادي'}, 
            {id: 2, name: 'الثاني الإعدادي'},
            {id: 3, name: 'الثالث الإعدادي'}
        ], 
        groups: [] 
      },

      // مصفوفة الطلاب
      students: []
    };
  },
  
  computed: {
    // خاصية محسوبة لمعرفة عدد الطلاب الذين تم تعديلهم
    changedCount() {
      return this.students.filter(s => s.is_changed).length;
    }
  },
    mounted() {

     const user = localStorage.getItem('user'); // بيانات المستخدم
  
     
     if(user){
      this.school_name =JSON.parse(user).school_name
     }
  },

  methods: {
    // 1. جلب المجموعات عند تغيير الصف
    async fetchGroups() {
      if (!this.filters.grade_id) return;
      // مثال: طلب API حقيقي
      // const res = await axios.get(`/api/groups?grade=${this.filters.grade_id}`);
      // this.lists.groups = res.data;
      
      // محاكاة
      this.lists.groups = [
          {id: 101, name: 'فصل 1/1'}, 
          {id: 102, name: 'فصل 1/2'},
          {id: 103, name: 'فصل 1/3'}
      ];
    },

    // 2. جلب الطلاب
    async fetchStudents() {
    //   if (!this.filters.group_id) return alert('الرجاء اختيار المجموعة');
      
      this.loading = true;
      this.searched = true;
      this.students = [];

      try {
        // مثال API:
        const res = await api.get('/getStudentWithSchool', { params: this.filters });
        // عند استلام البيانات، يجب إضافة خاصية is_changed: false لكل طالب
        this.students = res.data['students'].map(std => ({ ...std, is_changed: false }));

        // --- محاكاة لـ 300 طالب ---
        // setTimeout(() => {
            // const dummyData = Array.from({ length: 300 }, (_, i) => ({
        //         id: i + 1,
        //         name: `طالب تجريبي رقم ${i + 1}`,
        //         type: i % 10 === 0 ? 'damg' : 'regular', // كل 10 طلاب واحد دمج
        //         activity_1: "",
        //         activity_2: "",
        //         sports: "",
        //         // هام جداً: خاصية التتبع
        //         is_changed: false
        //     }));
            // this.students = dummyData;
            this.loading = false;
        // }, 800);
        // ------------------------

      } catch (error) {
        console.error(error);
        alert('حدث خطأ أثناء جلب الطلاب');
        this.loading = false;
      }
    },

    // 3. تتبع التغييرات (Dirty Checking)
    markDirty(student) {
      student.is_changed = true;
    },

    // 4. تعميم الاجتياز (Bulk Action)
    applyBulkPass() {
 
        if(!confirm('هل أنت متأكد؟ سيتم تعيين "اجتياز" لجميع الخلايا الفارغة.')) return;

        this.students.forEach(std => {
            let modified = false;
            
            // نعدل فقط الفارغ
            if(!std.activity_1) { std.activity_1 = 'pass'; modified = true; }
            if(!std.activity_2) { std.activity_2 = 'pass'; modified = true; }
            if(!std.sports)     { std.sports = 'pass';     modified = true; }

            // إذا تم تعديل أي حقل، نفعّل flag التغيير
            if(modified) std.is_changed = true;
        });
    },

    // 5. حفظ البيانات مجزأة (Chunking) - الدالة الأهم
    async saveChunks() {
        // أ) تصفية الطلاب المعدلين فقط
        const studentsToSave = this.students.filter(s => s.is_changed);

        if (studentsToSave.length === 0) {
            alert("لا توجد تغييرات جديدة لحفظها.");
            return;
        }

        this.isSaving = true;
        this.saveProgress = 0;

        // ب) إعداد التقسيم (50 طالب في كل دفعة)
        const chunkSize = 50; 
        const totalChunks = Math.ceil(studentsToSave.length / chunkSize);
        let hasError = false;

        // ج) حلقة التكرار للإرسال
        for (let i = 0; i < totalChunks; i++) {
            const start = i * chunkSize;
            const end = start + chunkSize;
            // اقتطاع الدفعة الحالية
            const chunkData = studentsToSave.slice(start, end);

            try {
                // إرسال الدفعة للباك اند
                // ملاحظة: تأكد أن رابط الـ API صحيح
                await api.post('/saveActivities', {
                    students: chunkData,
                    term_id: this.filters.term_id, // إرسال بيانات الفلتر أيضاً
                    // أي بيانات إضافية يحتاجها الباك اند
                });

                // تحديث النسبة المئوية
                this.saveProgress = Math.round(((i + 1) / totalChunks) * 100);

            } catch (error) {
                console.error(`خطأ في الدفعة رقم ${i + 1}`, error);
                hasError = true;
                // يمكنك اختيار إيقاف الحلقة هنا (break) أو الاستمرار لتجربة الباقي
            }
        }

        // د) الانتهاء
        this.isSaving = false;

        if (hasError) {
            alert("تمت العملية مع وجود أخطاء في الشبكة لبعض الدفعات.");
        } else {
            alert("تم حفظ جميع البيانات بنجاح!");
            // إعادة تعيين حالة التغيير للطلاب الذين تم حفظهم
            // (في حالة الإنتاج الحقيقي يفضل الاعتماد على رد السيرفر)
            this.students.forEach(s => s.is_changed = false);
            this.saveProgress = 0;
        }
    },

    // 6. تنسيق ألوان الحالة
    getStatusClass(status) {
        switch (status) {
            case 'pass': return 'text-success fw-bold border-success';
            case 'fail': return 'text-danger fw-bold border-danger';
            case 'absent': return 'bg-warning text-dark border-dark fw-bold';
            case 'exempt': return 'text-muted fst-italic';
            default: return '';
        }
    }
  }
};
</script>

<style scoped>
/* ألوان خلفية الأعمدة */
.bg-blue-light { background-color: #f0f8ff !important; }
.bg-green-light { background-color: #f0fff4 !important; }
.bg-yellow-light { background-color: #fffdf0 !important; }

/* حدود علوية للبطاقة */
.border-top-primary {
    border-top: 4px solid #0d6efd;
}

/* خط صغير */
.font-xs {
    font-size: 0.75rem;
}

/* تنسيق القوائم داخل الجدول */
.form-select-sm {
    padding-top: 0.2rem;
    padding-bottom: 0.2rem;
    font-size: 0.9rem;
    border-radius: 4px;
}

/* تثبيت رأس الجدول عند السكرول الطويل */
.sticky-header thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

/* تمييز الصف المعدل */
.table-warning {
    background-color: #fff3cd !important;
}
</style>